<template>
	<section class="intro">
		<section class="intro-shop">
			<p class="title">&nbsp;&nbsp;活动举办方</p>
			<section class="content">
				<img :src="shop_info.shop_logo">
				<section class="content-info">
					<p class="of">{{shop_info.shop_name || '微店卖家'}}</p>
					<span v-if="shop_info.weixin != ''" class="of2">微信：{{shop_info.weixin}}</span>
					<ul>
						<li class="grade" :class="gradeType" v-for="item in shop_credit.credit_num"></li>
					</ul>
				</section>
				<!--<section class="shop-btn" @click="goShop(shop_info.shop_url)">进店逛逛</section>-->
				<a class="shop-btn" :href="shop_info.shop_url">进店逛逛</a>
			</section>
		</section>
		<section class="intro-detail">	
			<p class="title">&nbsp;&nbsp;活动详情</p>
			<section v-if="description != ''" v-html="description"></section>
			<section class="no-detail" v-else>暂无详情</section>
		</section>
		<section class="intro-btn">
			<button type="button" @click="open">我也要创建</button>
			<p>注：本活动和奖品由商家支持，微店仅提供技术支持</p>
		</section>
	</section>
</template>

<style lang="less">
	@import '../css/intro.less';
</style>

<script>
	 import sdk from '../../common/js/wxsdk';
	import common from "../../common/js/common";
    import config from '../../../config/api.config';
	export default {
		name: 'intro',
		data() {
			return {
				description: '',
				shopId: this.$route.params.shopId || '',
				shop_info: {},
				shop_credit: {},
				gradeType: ''
			}
		},
		methods: {
			getShopInfo() {
				let self = this;
				common.jsonpVap({
                    url: config.getShopInfo,
                    dataIn: {
                    	shop_id: self.shopId,
                    	get_module: ["shop_info", "shop_credit"],
                    	source: "weidian-zhanhui"
                    },
                    ok: function (res) {
                        self.shop_info = res && res.result.shop_info;
                        self.shop_credit = res && res.result.shop_credit;
                        switch(self.shop_credit.credit_type) {
                        	case 1:
                        		self.gradeType = 'red-grade';
                        		break;
                        	case 2:
                        		self.gradeType = 'green-grade';
                        		break;
                        	case 3:
                        		self.gradeType = 'green-crown-grade';
                        		break;
                        	case 4:
                        		self.gradeType = 'yellow-crown-grade';
                        		break;
                        	default:
                        		self.gradeType = '';
                        }
                    },
                    error: function() {}
                });
			},
			open() {
				sdk.openApp();
			},
			goShop(url) {
				location.href = url;
			}
		},
		created() {
			document.title = "活动介绍";
			this.getShopInfo();
			let description = window.sessionStorage.getItem('description');
			this.description = description && description.replace(/\\n/g, '<br />').replace(/\\r/g, '<br />') || '';
		}
	}
</script>


/** WEBPACK FOOTER **
 ** intro.vue?7d64e9fe
 **/